export default __webpack_public_path__ + "static/media/consolidatedItemsSvg.74756411.svg";